import React from 'react';
import { Button, Typography, useTheme, useMediaQuery } from '@mui/material';

export default function ButtonAttribute({
  type,
  Bgcolor,
  color,
  bgColorHover,
  ColorHover,
  Label,
  startIcon,
  endIcon,
  width,
  height,
  action,
  hidden,
  disabled,
  sx = {}
}) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md'));

  return (
    <Button
    disabled={disabled}
      onClick={action}
      type={type}
      fullWidth={isMobile}
      startIcon={startIcon}
      endIcon={endIcon}
      sx={{
        fontFamily: '"Montserrat", sans-serif',
        marginBottom: { xs: 1, sm: 1.5, md: 2 },
        padding: {
          xs: '8px 24px',
          sm: '8px 24px',
          md: '8px 24px'
        },
        width: {
          xs: '100%',
          sm: width || 'auto',
          md: width ,
        },
        height: {
          xs: '40px',
          sm: '42px',
          md: height || '50px'
        },
        borderRadius: {
          xs: '8px',
          sm: '8px',
          md: '8px'
        },
        backgroundColor: Bgcolor,
        color: color,
        transition: 'all 0.3s ease',
        textTransform: 'none',
        fontWeight: {
          xs: 500,
          sm: 600,
          md: 500
        },
        fontSize: {
          xs: '13px',
          sm: '13px',
          md: '14px'
        },           
        boxShadow: "0 4px 6px rgba(99, 102, 241, 0.2)",                      
        '&:hover': {
          backgroundColor: bgColorHover || Bgcolor,
          color: ColorHover || color,
          transform: 'translateY(-2px)',
          boxShadow: "0 6px 12px rgba(99, 102, 241, 0.3)",
        },
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: { xs: '4px', sm: '6px', md: '8px' },
        minWidth: { xs: '40px', sm: '80px', md: '100px' },
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        ...sx
      }}
    >
      {isMobile && !Label && startIcon ? (
        startIcon
      ) : (
        <Typography
          variant="body1"
          sx={{
            fontSize: 'inherit',
            fontWeight: 'inherit',
            fontFamily: 'inherit',
            display: {
              xs: hidden ? 'none' : 'block',
              sm: hidden ? 'none' : 'block',
              md: 'block'
            },
            textAlign: 'center',
            lineHeight: 1.2
          }}
        >
          {Label}
        </Typography>
      )}
    </Button>
  );
}
